import { DataTable, type Table } from "../table";
import type { InvoiceReceivablesRow } from "./types";

export function ReceivablesInvoicesTable({
  table,
  displayRows,
  onOpenInvoice,
}: {
  table: Table<InvoiceReceivablesRow>;
  displayRows: InvoiceReceivablesRow[];
  onOpenInvoice: (externalId: string) => void;
}) {
  return (
    <DataTable
      table={table}
      displayRows={displayRows}
      onRowClick={(row) => onOpenInvoice(row.externalId)}
    />
  );
}
